import {LOCALE_SET_LOCALISATIONS} from '../locale/constants';
import {ROUTES_SET_API_ROUTES, ROUTES_SET_CLIENT_ROUTES} from '../routes/constants';
import {FORMS_SET_CONFIGS} from '../forms/constants';
import store from '../store';
import {IReduxStoreState} from '../../@interfaces';

const requiredActions = {
	[LOCALE_SET_LOCALISATIONS]: (state: IReduxStoreState): boolean => {
		return !state.locale.messagesLoaded;
	},
	[ROUTES_SET_CLIENT_ROUTES]: (state: IReduxStoreState): boolean => {
		return !state.routes.clientRoutesLoaded;
	},
	[ROUTES_SET_API_ROUTES]: (state: IReduxStoreState): boolean => {
		return !state.routes.apiRoutesLoaded;
	},
	[FORMS_SET_CONFIGS]: (state: IReduxStoreState): boolean => {
		return !state.forms.configsLoaded;
	},
};

export default function getRequiredActionsBeforeAppLoaded() {
	const state = store?.getState();

	return Object.keys(requiredActions).filter((key: any) => {
		return requiredActions[key as keyof typeof requiredActions](state);
	});
}
